export const STATUS_META = {
  draft: { label: "Draft", color: "148 6% 45%", bg: "44 21% 90%" },
  submitted: { label: "Submitted", color: "212 60% 45%", bg: "212 60% 92%" },
  comms_review: { label: "Communications Review", color: "200 55% 38%", bg: "200 55% 91%" },
  awaiting_leadership_approval: { label: "Awaiting Leadership Approval", color: "280 40% 45%", bg: "280 40% 93%" },
  approved_production_review: { label: "Approved for Production", color: "150 45% 32%", bg: "150 40% 90%" },
  approved_production_review_edits: { label: "Approved with Edits", color: "150 45% 32%", bg: "150 40% 88%" },
  denied_by_leadership: { label: "Denied by Leadership", color: "32 55% 38%", bg: "40 60% 90%" },
  production_review: { label: "Production Review", color: "200 55% 38%", bg: "200 55% 91%" },
  additional_info_required: { label: "Info Required", color: "38 80% 40%", bg: "43 90% 90%" },
  accepted_for_production: { label: "Accepted for Production", color: "200 55% 34%", bg: "200 55% 90%" },
  in_production: { label: "In Production", color: "212 60% 40%", bg: "212 60% 92%" },
  internal_comms_review: { label: "Internal Review", color: "245 45% 50%", bg: "245 45% 93%" },
  awaiting_requestor_approval: { label: "Awaiting Your Approval", color: "38 80% 38%", bg: "43 90% 90%" },
  changes_requested: { label: "Changes Requested", color: "24 70% 42%", bg: "24 80% 92%" },
  final_leadership_review: { label: "Final Leadership Review", color: "280 40% 45%", bg: "280 40% 93%" },
  final_approved: { label: "Final Approved", color: "150 45% 30%", bg: "150 40% 89%" },
  completed: { label: "Completed", color: "150 55% 28%", bg: "150 50% 88%" },
  released_to_requestor: { label: "Released to Requestor", color: "150 50% 30%", bg: "150 45% 89%" },
  downloaded: { label: "Downloaded", color: "148 30% 32%", bg: "150 30% 90%" },
  published: { label: "Published", color: "150 55% 28%", bg: "150 50% 88%" },
  closed: { label: "Closed", color: "148 8% 40%", bg: "44 15% 88%" },
  cancelled: { label: "Cancelled", color: "0 0% 45%", bg: "0 0% 91%" },
};

export const STATUS_ORDER = Object.keys(STATUS_META);

// statuses Communications may set (post leadership approval)
export const COMMS_STATUSES = [
  "production_review", "additional_info_required", "accepted_for_production",
  "in_production", "internal_comms_review", "awaiting_requestor_approval", "changes_requested",
  "completed", "released_to_requestor", "published", "closed",
];

export const NEWS_CATEGORIES = [
  "Announcement", "Event", "Meeting", "Program", "Service Project",
  "Member Recognition", "Deadline / Reminder", "Fundraiser", "General",
];

export const REQUEST_TYPES = [
  "Social Media Graphic/Flyer", "Brochure", "Toolkit", "Quarterly Newsletter",
  "Presentation", "Press Release/Media Advisory", "Multi Channel Campaign", "Other (explain)",
];

// Committee / Office Submitting Request (matches backend COMMITTEES)
export const COMMITTEES = [
  "Signature Program: AKA Foster the Future: From Here to Hope",
  "Target 1 - Educational Support & Advocacy",
  "Target 2 - AKA Family Matters",
  "Target 3 - Health Awareness & Well-Being",
  "Target 4 - Economic Growth & Success",
  "Target 5 - Environmental & Sustainability Action",
  "Target 6 - Arts Advocacy & Cultural Awareness",
  "Membership",
  "Archives",
  "Standards",
  "Bylaws",
  "Finance",
  "Technology",
  "Other/Special Committee",
];

export const DENIAL_REASONS = [
  "Request does not align with chapter priorities",
  "Event or activity has not been authorized",
  "Submitted information is incomplete",
  "Leadership approval was not obtained before the request was submitted",
  "Content does not meet chapter policy or protocol",
  "Request duplicates another submission",
  "Event has been postponed or canceled",
  "Requested communication is not appropriate for chapter distribution",
  "Additional planning is required before Communications involvement",
  "Other",
];

export const DISTRIBUTION_CHANNELS = [
  "Sunday News", "Quarterly Newsletter", "Social Media", "Event Signage",
  "Internal Communications", "Media/Press",
];

export const PRIORITIES = ["low", "normal", "high", "rush"];

export const ISSUE_SECTIONS = [
  "Leadership Messages", "Chapter Business", "Upcoming Events", "Programs and Service",
  "Committee Updates", "Member Recognition", "Community Partners",
  "Deadlines and Reminders", "Regional and International Updates",
];

export const LEADERSHIP_ROLES = ["president", "vice_president"];

export const ROLE_LABELS = {
  member: "Member",
  technology: "Technology Chairman",
  pr_chairman: "PR Chairman",
  comms_team: "Communications Team",
  comms_admin: "Communications Chairman",
  president: "Chapter President",
  vice_president: "Chapter Vice President",
};
